import Grid from '@mui/material/Grid'
import { ReactNode } from 'react'

export const FormItem = ({ children }: { children: ReactNode }) => (
  <Grid item xs={12} py={1}>
    {children}
  </Grid>
)
